import {Component, OnInit, TemplateRef, ViewChild, ElementRef, ViewChildren, QueryList} from '@angular/core';
import {Address, Module, Right, User} from '../../../models/models';
import {Translation} from '../../../models/translation';
import {LoginService} from '../../../services/login.service';
import {UserService} from '../../../services/user.service';
import {AddressService} from '../../../services/address.service';
import {PartnergroupService} from '../../../services/partnergroup.service';
import {ModuleService} from '../../../services/module.service';
import {RightService} from '../../../services/right.service';
import {CheckService} from '../../../services/check.service';
import {ChangePasswordService} from 'src/app/services/change-password.service';
import {MatLegacyCheckbox as MatCheckbox, MatLegacyCheckboxChange as MatCheckboxChange} from '@angular/material/legacy-checkbox';
import {MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from '@angular/material/legacy-dialog';
import {ColumnModel, ToolbarItems, EditSettingsModel} from '@syncfusion/ej2-angular-grids';
import {Observable} from 'rxjs';
import {DatePipe} from '@angular/common';
import {UntypedFormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import Swal from 'sweetalert2';
import {isNullOrUndefined} from 'validate-typescript/lib/common';

@Component({
  selector: 'app-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.css'],
  providers: [DatePipe]
})
export class UsermanagementComponent implements OnInit {
  // @ts-ignore
  @ViewChild('matDialog') matDialog: TemplateRef<MatDialog>;
  // @ts-ignore
  @ViewChild('primaryAddressInput') primaryAddressInput: ElementRef;
  // @ts-ignore
  @ViewChild('homeDeliveryPartnerAddressInput') homeDeliveryPartnerAddressInput: ElementRef;
  // @ts-ignore
  @ViewChild('partnerInput') partnerInput: ElementRef;
  // @ts-ignore
  @ViewChild('partnerGroupInput') partnerGroupInput: ElementRef;
  // @ts-ignore
  @ViewChildren('moduleCheckboxItems', { static: false }) moduleCheckboxItems: QueryList<MatCheckbox>;
  // @ts-ignore
  @ViewChildren('rightCheckboxItems', { static: false }) rightCheckboxItems: QueryList<MatCheckbox>;

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private userService: UserService,
    private changePasswordService: ChangePasswordService,
    private addressService: AddressService,
    private partnerGroupService: PartnergroupService,
    private moduleService: ModuleService,
    private rightService: RightService,
    private datepipe: DatePipe,
    private dialog: MatDialog
  ) { }

  public user: User;
  public translation: Translation;
  public columns: ColumnModel[];
  public allowPaging = true;
  public pageSettings = true;
  public toolbar: ToolbarItems[];
  public readonly = true;
  public readonlyModules = true;
  public readonlyRights = true;
  public readonlyTransportRights = true;
  public readonlyStatusRights = true;
  public readonlyTransportModule = true;
  public readonlyStatusModule = true;
  public hidden = true;
  public editSettings: EditSettingsModel;
  public config: MatDialogConfig = {width: '80vw', height: '80%'};
  // Base Sources
  public dataSource: User[] = [];
  public languages = ['DE', 'FR', 'IT', 'EN'];
  public addresses: Address[];
  public partnerGroups: string[] = [];
  public modules: Module[] = [];
  public rights: Right[] = [];
  public onNewUserModulesToAdd: Module[] = [];
  public onNewUserRightsToAdd: Right[] = [];
  // End Base Sources
  public autoCompletePrimaryAddress = new UntypedFormControl();
  public autoCompleteHomeDeliveryPartnerAddress = new UntypedFormControl();
  public autoCompletePartner = new UntypedFormControl();
  public autoCompletePartnerGroup = new UntypedFormControl();
  public filteredPrimaryAddresses: Observable<Address[]>;
  public filteredHomeDeliveryAddresses: Observable<Address[]>;
  public filteredPartners: Observable<Address[]>;
  public filteredPartnerGroups: Observable<string[]>;
  public usersPrimaryAddress: Address = new Address();
  public primaryAddressArray: string[] = [];
  public usersHomeDeliveryPartnerAddress: Address = new Address();
  public homeDeliveryPartnerAddressArray: string[] = [];
  public partnerArray: string[] = [];
  public partnerGroupArray: string[] = [];
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = false;
  public creatorName = '';
  public lastUpdate = '';
  public creationDate = '';
  public displayResetButton = true;
  public currentUserIsAdmin = false;
  public currentUserIsSystemAdmin = false;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRightStatus(2);
    this.checkService.checkModule(70);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.currentUserIsAdmin = +sessionStorage.getItem('RightStatus') <= 1;
    this.currentUserIsSystemAdmin = +sessionStorage.getItem('RightStatus') === 0;
    this.loadUsers();
    this.loadAddresses();
    this.loadPartnerGroups();
    this.loadModules();
    this.loadRights();
    this.initGrid();
  }

  private loadUsers() {
    this.userService.getUsersByRight(+sessionStorage.getItem('UserId')).subscribe(response => {
      if (response.Ok) {
        this.dataSource = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  private loadAddresses() {
    this.addressService.getAddresses().subscribe(response => {
      if (response.Ok) {
        this.addresses = response.Obj;
        this.filterPrimaryAddresses();
        this.filterHomeDeliveryPartnerAddresses();
        this.filterPartners();
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  private loadPartnerGroups() {
    this.partnerGroupService.getPartnerGroups().subscribe(response => {
      if (response.Ok) {
        this.partnerGroups = response.Obj;
        this.filterPartnerGroups();
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  private loadModules() {
    switch (+sessionStorage.getItem('RightStatus')) {
      case 0:
      case 1:
        this.moduleService.getModules().subscribe(response => {
          if (response.Ok) {
            this.modules = response.Obj;
            this.setReadonly();
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 2:
      case 3:
        this.moduleService.getModulesByUserId(+sessionStorage.getItem('UserId')).subscribe(response => {
          if (response.Ok) {
            this.modules = response.Obj;
            this.setReadonly();
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      default: this.setReadonly();
    }
  }

  private loadRights() {
    switch (+sessionStorage.getItem('RightStatus')) {
      case 0:
      case 1:
        this.rightService.getRights().subscribe(response => {
          if (response.Ok) {
            this.rights = response.Obj;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
      case 2:
      case 3:
        this.rightService.getRightsByUserId(+sessionStorage.getItem('UserId')).subscribe(response => {
          if (response.Ok) {
            this.rights = response.Obj;
          } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
          if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
        break;
    }
  }

  private initGrid() {
    switch (+sessionStorage.getItem('RightStatus')) {
      case 0:
      case 1:
      case 2:
        this.toolbar = ['Add', 'Edit', 'Delete', 'Cancel', 'Search'];
        break;
      case 3:
        this.toolbar = ['Search'];
        break;
    }
    this.editSettings =  {
      allowAdding: true,
      allowEditing: true,
      allowDeleting: true,
      mode: 'Dialog',
      allowEditOnDblClick: true,
      showConfirmDialog: false,
      showDeleteConfirmDialog: false };
    this.columns = [
      {
        field: 'UserId',
        headerText: this.translation.Id,
        textAlign: 'Left',
        isPrimaryKey: true,
        visible: false
      },
      {
        field: 'Email',
        headerText: this.translation.Email,
        textAlign: 'Left'
      },
      {
        field: 'LoginName',
        headerText: this.translation.LoginName,
        textAlign: 'Left'
      },
      {
        field: 'FirstName',
        headerText: this.translation.FirstName,
        textAlign: 'Left'
      },
      {
        field: 'LastName',
        headerText: this.translation.LastName,
        textAlign: 'Left'
      },
      {
        field: 'Phone',
        headerText: this.translation.Phone,
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'PrimaryAddressId',
        headerText: this.translation.PrimaryAddress,
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'HomeDeliveryPartnerAddressId',
        headerText: this.translation.HomeDeliveryPartnerAddress,
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'Addresses',
        headerText: this.translation.Partner,
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'Companies',
        headerText: this.translation.Companies,
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'LastUpdate',
        headerText: this.translation.LastUpdate,
        textAlign: 'Left',
        visible: false,
      },
      {
        field: 'CreationDate',
        headerText: this.translation.CreationDate,
        textAlign: 'Left',
        visible: false,
      },
    ];
  }

  private setReadonly() {
    switch (+sessionStorage.getItem('RightStatus')) {
      case 0:
      case 1:
        this.readonly = false;
        this.readonlyModules = false;
        this.readonlyRights = false;
        this.hidden = false;
        break;
      case 2:
        this.readonly = false;
        this.modules.forEach(module => {
          if (module.ModuleId === 10) {
            this.readonlyTransportRights = false;
            this.readonlyTransportModule = false;
          }
          if (module.ModuleId === 80) {
            this.readonlyStatusRights = false;
            this.readonlyStatusModule = false;
          }
        });
        break;
      default: break;
    }
  }

  private filterPrimaryAddresses() {
    this.filteredPrimaryAddresses = this.autoCompletePrimaryAddress.valueChanges.pipe(
      startWith(''),
      map(value => this._filterPrimaryAddresses(value))
    );
  }
  private _filterPrimaryAddresses(value: string): Address[] {
    let filterValue = value;
    if (!String(value)) { return this.addresses; }
    if (!Number(value) && value !== null) { filterValue = value?.toLowerCase(); }
    return this.addresses.filter(address =>
      address.PartnerAid?.toLowerCase().includes(filterValue) ||
      address.Description?.toLowerCase().includes(filterValue) ||
      address.DeliveryStreet?.toLowerCase().includes(filterValue) ||
      address.DeliveryCity?.toLowerCase().includes(filterValue) ||
      address.DeliveryZip.includes(filterValue) ||
      address.PartnerFid.includes(filterValue));
  }

  private filterHomeDeliveryPartnerAddresses() {
    this.filteredHomeDeliveryAddresses = this.autoCompleteHomeDeliveryPartnerAddress.valueChanges.pipe(
      startWith(''),
      map(value => this._filterHomeDeliveryPartnerAddresses(value))
    );
  }
  private _filterHomeDeliveryPartnerAddresses(value: string): Address[] {
    let filterValue = value;
    if (!String(value)) { return this.addresses; }
    if (!Number(value) && value !== null) { filterValue = value?.toLowerCase(); }
    return this.addresses.filter(address =>
      address.PartnerAid?.toLowerCase().includes(filterValue) ||
      address.Description?.toLowerCase().includes(filterValue) ||
      address.DeliveryStreet?.toLowerCase().includes(filterValue) ||
      address.DeliveryCity?.toLowerCase().includes(filterValue) ||
      address.DeliveryZip.includes(filterValue) ||
      address.PartnerFid.includes(filterValue));
  }

  private filterPartners() {
    this.filteredPartners = this.autoCompletePartner.valueChanges.pipe(
      startWith(''),
      map(value => this._filterPartners(value))
    );
  }
  private _filterPartners(value: string): Address[] {
    let filterValue = value;
    if (!String(value)) { return this.addresses; }
    if (!Number(value) && value !== null) { filterValue = value.toLowerCase(); }
    return this.addresses.filter(address =>
      address.PartnerAid.toLowerCase().includes(filterValue) ||
      address.Description.toLowerCase().includes(filterValue) ||
      address.DeliveryStreet.toLowerCase().includes(filterValue) ||
      address.DeliveryCity.toLowerCase().includes(filterValue) ||
      address.DeliveryZip.includes(filterValue) ||
      address.PartnerFid.includes(filterValue));
  }

  private _filterPartnerGroups(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (!String(value)) { return this.partnerGroups; }
    return this.partnerGroups.filter(partnerGroup =>
      partnerGroup.toLowerCase().includes(filterValue));
  }
  private filterPartnerGroups() {
    this.filteredPartnerGroups = this.autoCompletePartnerGroup.valueChanges.pipe(
      startWith(''),
      map(value => this._filterPartnerGroups(value))
    );
  }

  open(event) {
    this.user = event.rowData;
    this.dialog.open(this.matDialog, this.config);
  }

  save() {
    this.user.PrimaryAddressAid = '';
    this.primaryAddressArray.forEach(o => {
      this.user.PrimaryAddressAid += o;
    });
    this.user.HomeDeliveryPartnerAddressAid = '';
    this.homeDeliveryPartnerAddressArray.forEach(o => {
      this.user.HomeDeliveryPartnerAddressAid += o;
    });
    this.user.Addresses = '';
    this.partnerArray.forEach(o => {
      this.user.Addresses += o + ',';
    });
    this.user.Companies = '';
    this.partnerGroupArray.forEach(o => {
      this.user.Companies += o + ',';
    });
    if (this.user.UserId === 0) {
      this.user.Modules = this.onNewUserModulesToAdd;
      this.user.Rights = this.onNewUserRightsToAdd;
      this.userService.insertUser(this.user).subscribe(response => {
        if (response.Ok) {
          Swal.fire(this.translation.UserCreated, this.translation.AutomaticPasswordAssignment + ': cotraPortal2021', 'success').then(_ => this.loadUsers());
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: this.translation.UserNotSavedMessage, icon: response.Ok ? 'success' : 'error'}).then(_ => this.loadUsers()); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else {
      this.userService.updateUser(this.user.UserId, this.user).subscribe(response => {
        if (response.Ok) {
          Swal.fire(this.translation.Success, this.translation.UserSuccessfullySavedMessage, 'success').then(_ => this.loadUsers());
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: this.translation.UserNotSavedMessage, icon: response.Ok ? 'success' : 'error'}).then(_ => this.loadUsers()); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    }
    this.cancel();
  }

  cancel() {
    this.user = new User();
    this.usersPrimaryAddress = new Address();
    this.primaryAddressArray = [];
    this.usersHomeDeliveryPartnerAddress = new Address();
    this.homeDeliveryPartnerAddressArray = [];
    this.partnerArray = [];
    this.partnerGroupArray = [];
    this.lastUpdate = '';
    this.creationDate = '';
    this.creatorName = '';
    this.dialog.closeAll();
  }

  actionBegin(args: any) {
    if (args.requestType === 'add') {
      args.cancel = true;
      this.add();
    }
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
      this.edit(args);
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      this.delete(args);
    }
  }

  add() {
    this.displayResetButton = false;
    this.user = new User();
    this.user.UserId = 0;

    // Get PrimaryAddress
    this.user.PrimaryAddressAid = JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid;
    this.addressService.getAddressByPartnerAid(this.user.PrimaryAddressAid).subscribe(response => {
      if (response.Ok) {
        this.addPrimaryAddress(response.Obj.PartnerAid);
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }

      // Get HomeDeliveryPartnerAddress
      let homeDeliveryAddress = sessionStorage.getItem('HomedeliveryAddress');
      if (homeDeliveryAddress != null) {
        if (homeDeliveryAddress != '') {
          this.user.HomeDeliveryPartnerAddressAid = JSON.parse(homeDeliveryAddress).PartnerAid;
          this.addressService.getAddressByPartnerAid(this.user.HomeDeliveryPartnerAddressAid).subscribe(response2 => {
            if (response2.Ok) {
              this.addHomeDeliveryPartnerAddress(response2.Obj.PartnerAid);
            } else if (response2.Msg === 'Internal Server Error') { console.log(response2.Ex); }
            if (response2.Msg) { this.toast.fire({title: response2.Msg, icon: response2.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        }
      }
      

      this.partnerArray = sessionStorage.getItem('Addresses').split(',');
      const partnerIndex = this.partnerArray.indexOf('');
      if (partnerIndex >= 0) { this.partnerArray.splice(partnerIndex, 1); }
      this.partnerGroupArray = sessionStorage.getItem('Companies').split(',');
      const partnerGroupIndex = this.partnerGroupArray.indexOf('');
      if (partnerGroupIndex >= 0) { this.partnerGroupArray.splice(partnerGroupIndex, 1); }
      this.lastUpdate = '';
      this.creationDate = this.datepipe.transform(new Date(), 'dd.MM.yyyy');
      this.creatorName = '';
      this.user.Modules = this.modules;
      this.user.Rights = this. rights;
      this.user.CreatorUserId = +sessionStorage.getItem('UserId');
      this.user.RightStatus = +sessionStorage.getItem('RightStatus') + 1;
      this.user.MultiPartnerUser = sessionStorage.getItem('MultiPartnerUser') === 'true';
      this.user.ConfirmationMail = false;
      this.user.ConfirmationMailAsked = false;
      this.user.SaturdayDelivery = sessionStorage.getItem('SaturdayDelivery') === 'true';
      if (this.user.RightStatus > 3) { this.user.RightStatus = 3; }

      const dialogRef = this.dialog.open(this.matDialog, this.config);
      dialogRef.afterClosed().subscribe(() => {
        this.cancel();
      });
      
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  edit(args: any) {
    this.displayResetButton = true;
    this.user = args.rowData;

    // Set Partners
    this.partnerArray = this.user.Addresses.split(',');
    const partnerIndex = this.partnerArray.indexOf('');
    if (partnerIndex >= 0) { this.partnerArray.splice(partnerIndex, 1); }
    // Set Companies
    this.partnerGroupArray = this.user.Companies.split(',');
    const partnerGroupIndex = this.partnerGroupArray.indexOf('');
    if (partnerGroupIndex >= 0) { this.partnerGroupArray.splice(partnerGroupIndex, 1); }

    // Set Dates
    this.lastUpdate = this.datepipe.transform(this.user.LastUpdate, 'dd.MM.yyyy HH:mm');
    this.creationDate = this.datepipe.transform(this.user.CreationDate, 'dd.MM.yyyy HH:mm');

    // Set CreatorName
    this.userService.getUserById(this.user.CreatorUserId).subscribe(response => {
      if (response.Ok) {
        this.creatorName = response.Obj.FirstName + ' ' + response.Obj.LastName;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });

    const dialogRef = this.dialog.open(this.matDialog, this.config);
    dialogRef.afterClosed().subscribe(() => {
      this.cancel();
    });

    // Set Modules
    this.moduleService.getModulesByUserId(this.user.UserId).subscribe((responseModule) => {
      if (responseModule.Ok) {
        this.moduleCheckboxItems.forEach((item: MatCheckbox) => {
          item.checked = (!isNullOrUndefined(responseModule.Obj.find(o => o.ModuleId === +item.id.split('e')[1])));
        });

        // Set Rights
        this.rightService.getRightsByUserId(this.user.UserId).subscribe(responseRight => {
          if (responseRight.Ok) {
            this.rightCheckboxItems.forEach((item: MatCheckbox) => {
              item.checked = (!isNullOrUndefined(responseRight.Obj.find(o => o.RightId === +item.id.split('t')[1])));
            });
          } else if (responseRight.Msg === 'Internal Server Error') { console.log(responseRight.Ex); }
          if (responseRight.Msg) { this.toast.fire({title: responseRight.Msg, icon: responseRight.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      } else if (responseModule.Msg === 'Internal Server Error') { console.log(responseModule.Ex); }
      if (responseModule.Msg) { this.toast.fire({title: responseModule.Msg, icon: responseModule.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });

    // Set PrimaryAddress
    if (this.user.WnExternal) {
      this.addPrimaryAddress('');
    } else {
      let primaryAddressAidOverwrite = args.rowData.PrimaryAddressAid;
      if (primaryAddressAidOverwrite === 'OLYMSIONVW+NF') { primaryAddressAidOverwrite = 'OLYMSIONVWNF'; }
      this.addressService.getAddressByPartnerAid(primaryAddressAidOverwrite).subscribe(responseAddress => {
        if (responseAddress.Ok) {
          this.addPrimaryAddress(responseAddress.Obj.PartnerAid);
        } else if (responseAddress.Msg === 'Internal Server Error') { console.log(responseAddress.Ex); }
        if (responseAddress.Msg) { this.toast.fire({title: responseAddress.Msg, icon: responseAddress.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });

      // Set HomeDeliveryAddress
      let homeDeliveryPartnerAddressAid = args.rowData.HomeDeliveryPartnerAddressAid;
      if (homeDeliveryPartnerAddressAid != null) {
        if (homeDeliveryPartnerAddressAid != "") {
          this.addressService.getAddressByPartnerAid(homeDeliveryPartnerAddressAid).subscribe(responseAddress => {
            if (responseAddress.Ok) {
              this.addHomeDeliveryPartnerAddress(responseAddress.Obj.PartnerAid);
            } else if (responseAddress.Msg === 'Internal Server Error') { console.log(responseAddress.Ex); }
            if (responseAddress.Msg) { this.toast.fire({title: responseAddress.Msg, icon: responseAddress.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire(this.translation.InternalServerError); });
        }
      }
    }
  }

  delete(args: any) {
    if (+sessionStorage.getItem('UserId') === +args.data[0].UserId) {
      Swal.fire(this.translation.Error, this.translation.YouCantDeleteYourself, 'error');
      return;
    }
    this.user = args.data[0];
    Swal.fire({
      title: this.translation.Delete + '?',
      text: this.translation.DoYouReallyWantToDeleteThisUser + ': ' + this.user.FirstName + ' ' + this.user.LastName + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translation.Delete,
      cancelButtonText: this.translation.Cancel,
    }).then((result) => {
      if (result.value) {
        this.deleteUser(this.user.UserId);
      }
    });
  }

  deleteUser(userId) {
    this.userService.deleteUser(userId).subscribe(response => {
      if (response.Ok) {
        Swal.fire(this.translation.Success, this.translation.UserSuccessfullyDeletedMessage, 'success').then(_ => this.loadUsers());
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: this.translation.UserNotDeletedMessage, icon: response.Ok ? 'success' : 'error'}).then(_ => this.loadUsers()); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  addPrimaryAddress(partnerAid: string) {
    if (this.primaryAddressArray.length === 0) {
      if (!this.primaryAddressArray.includes(partnerAid)) { this.primaryAddressArray.push(partnerAid); }
      this.autoCompletePrimaryAddress.setValue('');
      if (this.primaryAddressInput !== null && this.primaryAddressInput !== undefined) { this.primaryAddressInput.nativeElement.value = ''; }
      this.filterPrimaryAddresses();
    }
  }

  addHomeDeliveryPartnerAddress(partnerAid: string) {
    if (this.homeDeliveryPartnerAddressArray.length === 0) {
      if (!this.homeDeliveryPartnerAddressArray.includes(partnerAid)) { this.homeDeliveryPartnerAddressArray.push(partnerAid); }
      this.autoCompleteHomeDeliveryPartnerAddress.setValue('');
      if (this.homeDeliveryPartnerAddressInput !== null && this.homeDeliveryPartnerAddressInput !== undefined) { this.homeDeliveryPartnerAddressInput.nativeElement.value = ''; }
      this.filterHomeDeliveryPartnerAddresses();
    }
  }

  removePrimaryAddress(primaryAddressAid: string): void {
    const indexPrimaryAddress = this.primaryAddressArray.indexOf(primaryAddressAid);
    if (indexPrimaryAddress >= 0) { this.primaryAddressArray.splice(indexPrimaryAddress, 1); }
  }

  removeHomeDeliveryPartnerAddress(primaryAddressAid: string): void {
    const indexHomeDeliveryPartnerAddress = this.homeDeliveryPartnerAddressArray.indexOf(primaryAddressAid);
    if (indexHomeDeliveryPartnerAddress >= 0) { this.homeDeliveryPartnerAddressArray.splice(indexHomeDeliveryPartnerAddress, 1); }
  }

  addPartner(partnerAid: string) {
    if (!this.partnerArray.includes(partnerAid)) { this.partnerArray.push(partnerAid); }
    this.autoCompletePartner.setValue('');
    this.partnerInput.nativeElement.value = '';
    this.filterPartners();
  }

  removePartner(partnerAid: string): void {
    const indexPartner = this.partnerArray.indexOf(partnerAid);
    if (indexPartner >= 0) { this.partnerArray.splice(indexPartner, 1); }
  }

  addPartnerGroup(partnerGroup: string) {
    if (!this.partnerGroupArray.includes(partnerGroup)) { this.partnerGroupArray.push(partnerGroup); }
    this.autoCompletePartnerGroup.setValue('');
    this.partnerGroupInput.nativeElement.value = '';
    this.filterPartnerGroups();
  }

  removePartnerGroup(partnerGroup: string): void {
    const index = this.partnerGroupArray.indexOf(partnerGroup);
    if (index >= 0) { this.partnerGroupArray.splice(index, 1); }
  }

  addOrRemoveUserModule($event: MatCheckboxChange, moduleId: number) {
    const tempModule = new Module();
    tempModule.ModuleId = moduleId;
    if (this.user.UserId === null || this.user.UserId === 0) {
      if ($event.checked) {
        this.onNewUserModulesToAdd.push(tempModule);
      } else {
        this.onNewUserModulesToAdd = this.onNewUserModulesToAdd.filter(({ ModuleId }) => ModuleId !== moduleId);
      }
    }
    else {
      if ($event.checked) {
        this.user.Modules.push(tempModule);
      } else {
        this.user.Modules = this.user.Modules.filter(({ ModuleId }) => ModuleId !== moduleId);
      }
    }
  }

  addOrRemoveUserRight($event: MatCheckboxChange, rightId: number) {
    const tempRight = new Right();
    tempRight.RightId = rightId;
    if (this.user.UserId === null || this.user.UserId === 0) {
      if ($event.checked) {
        this.onNewUserRightsToAdd.push(tempRight);
      } else {
        this.onNewUserRightsToAdd = this.onNewUserRightsToAdd.filter(({ RightId }) => RightId !== rightId);
      }
    }
    else {
      if ($event.checked) {
        this.user.Rights.push(tempRight);
      } else {
        this.user.Rights = this.user.Rights.filter(({ RightId }) => RightId !== rightId);
      }
    }
  }

  resetPassword() {
    this.changePasswordService.resetPasswordByUserId(this.user.UserId).subscribe(response => {
      if (response.Ok) {
        if (response.Obj) {
          Swal.fire(this.translation.Success, this.translation.PasswordResetSuccessMessage, 'success');
        } else {
          Swal.fire(this.translation.Error, this.translation.PasswordResetErrorMessage, 'error');
        }
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  userSettingChange($event: MatCheckboxChange, setting: string) {
    switch (setting) {
      case 'multiPartnerUser': this.user.MultiPartnerUser = $event.checked; break;
      case 'confirmationMail': this.user.ConfirmationMail = $event.checked; break;
      case 'confirmationMailAsked': this.user.ConfirmationMailAsked = $event.checked; break;
      case 'saturdayDelivery': this.user.SaturdayDelivery = $event.checked; break;
      case 'wnExternal': this.user.WnExternal = $event.checked; break;
    }
  }
}
